/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
App.message_modal_charts = {

  adjust_gradient(plan_credits, available_credits) {
    let bottom_color, color_stop, top_color;
    const green = "#5eba32";
    const overage_orange = "#E8A01A";

    // just in case it's negative...
    const ca = available_credits <= 0 ? 1 : available_credits;
    const avp = Math.floor((ca/plan_credits)*100);

    const root_color = avp < 30 ? overage_orange : green;

    const used_color = App.message_modal_charts.shade_color(root_color, -0.30);
    const now_color = App.message_modal_charts.shade_color(root_color, -0.55);

    App.message_modal_charts.set_chart_border_and_color('.js-message-modal-footer__credits-cost', now_color);
    App.message_modal_charts.set_chart_border_and_color('.js-message-modal-footer__credits-used', used_color);

    if (avp <= 15) {  // mostly orange
      top_color = App.message_modal_charts.blend_colors(green, overage_orange, 0.75);
      bottom_color = overage_orange;
      color_stop = `${overage_orange} 25%,`;
    } else if (avp < 30) {
      top_color = App.message_modal_charts.blend_colors(green, overage_orange, 0.65);
      bottom_color = overage_orange;
      color_stop = `${overage_orange} 35%,`;
    } else if (avp < 70) {
      top_color = green;
      bottom_color = overage_orange;
      color_stop = "";
    } else if (avp < 85) {
      top_color = green;
      bottom_color = App.message_modal_charts.blend_colors(green, overage_orange, 0.35);
      color_stop = `${green} 65%,`;
    } else {
      top_color = green;
      bottom_color = App.message_modal_charts.blend_colors(green, overage_orange, 0.25);
      color_stop = `${green} 75%,`;
    }

    const credits = $('.js-message-modal-footer__credits');
    const image_text = `linear-gradient(to right,${top_color} 0%,${color_stop}${bottom_color} 100%)`;
    return credits.css("background-image", image_text);
  },

  // via http://stackoverflow.com/questions/5560248/programmatically-lighten-or-darken-a-hex-color-or-rgb-and-blend-colors
  blend_colors(c1, c2, p) {
    const f = parseInt(c1.slice(1),16);
    const t = parseInt(c2.slice(1),16);
    const R1 = f>>16;
    const G1 = (f>>8)&0x00FF;
    const B1 = f&0x0000FF;
    const R2 = t>>16;
    const G2 = (t>>8)&0x00FF;
    const B2 = t&0x0000FF;
    return "#"+(0x1000000+((Math.round((R2-R1)*p)+R1)*0x10000)+((Math.round((G2-G1)*p)+G1)*0x100)+(Math.round((B2-B1)*p)+B1)).toString(16).slice(1);
  },

  set_chart_border_and_color(class_name, color) {
    $(class_name).css('color', color);
    return $(`${class_name}>p:first-child`).css('border-color', color);
  },

  shade_color(color, percent) {
    const f = parseInt(color.slice(1),16);
    const t = percent<0 ? 0 : 255;
    const p = percent<0 ? percent*-1 : percent;
    const R=f>>16;
    const G=(f>>8)&0x00FF;
    const B=f&0x0000FF;
    return "#"+(0x1000000+((Math.round((t-R)*p)+R)*0x10000)+((Math.round((t-G)*p)+G)*0x100)+(Math.round((t-B)*p)+B)).toString(16).slice(1);
  },

  update_charts(chart_id, unused_credits, pending_credits, plan_credits, used_credits) {
    // This is retarded.
    let colors, data;
    const available = unused_credits - pending_credits;
    const used_color = $('.js-message-modal-footer__credits-used').css('color');
    const now_color = $('.js-message-modal-footer__credits-cost').css('color');

    // Pop out credit counter when there are fewer than 10% of credits remaining.
    if (available <= (0.10*plan_credits)) {
      $('.js-message-modal-footer-container').addClass('open');
    }

    // Handle case when there aren't enough credits
    if (available <= 0) {
      colors = [used_color];
      data = [["Used", used_credits]];

      $('.js-message-modal-postscript-container').toggleClass('open', pending_credits > 0);

      App.modal_ready(() => App.message_modal_upgrade.handle_serious_overage(available));

    } else {
      $('.js-message-modal-postscript-container').removeClass('open');
      colors = [used_color, now_color, "#ffffff" ];
      data = [["Used", used_credits],
              ["This message", pending_credits],
              ["Available", available]];
    }

    return new Chartkick.PieChart(chart_id,
                           data,
                           {
                             colors,
                             library: {
                               backgroundColor: "transparent",
                               legend: { position: "none" },
                               pieHole: 0.7,
                               pieSliceBorderColor: "transparent",
                               pieSliceText: "none"
                             }
                           }
                          );
  }
};
